import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DxfViewerComponent } from './dxf-viewer.component';

@NgModule({
    imports: [CommonModule],
    exports: [DxfViewerComponent],
    declarations: [DxfViewerComponent],
    providers: [],
})
export class DxfViewerModule { }
